import React from 'react';
import PropTypes from 'prop-types';
import Rule from '../criteria-rule';
import { detach } from '../util';

/**
 * Rule component requiring a maximum length of characters.
 *
 * @displayName MaxCharactersRule
 *
 * @param {Object} props Props
 * @returns {ReactElement} ReactElement
 */
export default function MaxCharactersRule(props) {
  var [a, b] = detach(props, 'max');
  return (
    <Rule validate={ (v) => v.length <= a.max } { ...b }>
      { props.children }
    </Rule>
  );
}

/**
 * PropType validation.
 *
 * @type {Object}
 * @private
 */
MaxCharactersRule.propTypes = {
  /** The maximum number of characters (inclusive) */
  max: PropTypes.number.isRequired,
  /** Child elements */
  children: PropTypes.node
};
